import { get } from 'lodash-es';
import { pageDefinition } from 'site-modules/shared/pages/page';
import { ModelPreloader } from 'client/data/luckdragon/redux/model-preloader';
import { CmsModel } from 'client/data/models/cms';
import { getModelState } from 'client/data/luckdragon/model';
import { parseContent } from 'client/data/cms/content';
import { getMeta } from 'site-modules/shared/utils/seo-helper';
import { getBreadcrumbSchema } from 'client/seo/schemas/breadcrumbs';
import { getBaseBreadcrumb, getHomeBreadcrumb } from 'site-modules/shared/components/breadcrumbs/helper';
import { ABOUT_BREADCRUMB } from 'client/site-modules/editorial/constants/about';
import { PressDecorator } from 'site-modules/editorial/pages/about/press/press-decorator';
import { ExecutiveBios, EXECUTIVE_BIOS_CONTENT_FILE_PATH } from './executive-bios';

export const pageOptions = {
  name: 'other_about_us_executive_bios',
  category: 'other_about_us_executive_bios',
  decorator: PressDecorator,
  preload: store => {
    const preloader = new ModelPreloader(store);

    preloader.resolve(`content["${EXECUTIVE_BIOS_CONTENT_FILE_PATH}"]`, CmsModel);

    return preloader.load();
  },
  seo: (state, props) => {
    const modelState = getModelState(state);
    const pathname = get(props, 'location.pathname');
    const content = modelState.get(`content["${EXECUTIVE_BIOS_CONTENT_FILE_PATH}"]`, CmsModel);
    const parsedContent = parseContent(content);
    const title = get(content, 'title', '');

    return {
      ...getMeta(parsedContent),
      jsonld: [getBreadcrumbSchema([getHomeBreadcrumb(), ABOUT_BREADCRUMB, getBaseBreadcrumb(title, pathname)])],
    };
  },
  component: ExecutiveBios,
};

export default pageDefinition(pageOptions);
